import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import {
  getVendorWithSuperCategory,
  getAllSuperCategory,
  getAllCategory,
  getAllRestaurantType
} from '../../../store/actions/user/User';
import GridItem from '../../Grid/GridItem';
import LiquorCard from './LiquorCard';
import NoData from '../NoData/NoData';
import Footer from '../Footer/Footer';

const useStyles = makeStyles((theme) => ({
  vendorContainer: {
    maxWidth: '1024px',
    margin: '4rem auto',
    [theme.breakpoints.down('sm')]: {
      padding: '6rem 2rem'
    }
  },
  superCategoryDetail: {
    display: 'flex'
  },
  superCategoryImage: {
    paddingTop: '0rem',
    fontSize: '24px',
    fontWeight: 'bold'
  },
  vendorListing: {
    marginTop: '1rem',
    textTransform: 'capitalize'
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    marginTop: '6px',
    width: '100%',
    textTransform: 'capitalize'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    textTransform: 'capitalize'
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box width="100%">{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

const LiquorVendor = (props) => {
  const [isRestaurant, updateIsRestaurant] = useState(false);
  const [superCategory, updateSuperCategory] = useState({});
  const [isLoading, updateIsLoading] = useState(false);
  const [vendorBySuperCategory, updateVendorBySuperCategory] = useState([]);

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    updateIsLoading(true);
    const { superCategoryId } = props.match.params;
    const payload = {
      superCategoryId: superCategoryId,
      latitude: localStorage.getItem('latitude') || '-33.865143',
      longitude: localStorage.getItem('longitude') || '151.209900'
    };
    props.getAllSuperCategory();
    props.getAllCategory(superCategoryId);
    props.getAllRestaurantType(superCategoryId);
    props
      .getVendorWithSuperCategory(payload)
      .then((resp) => {
        updateVendorBySuperCategory(resp?.data);
        updateIsLoading(false);
      })
      .catch((err) => {
        updateIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (props?.superCategories) {
      const { superCategoryId } = props.match.params;
      const superCategory = props?.superCategories?.find((item) => {
        updateIsRestaurant(item.isRestaurant);
        return item.id === superCategoryId;
      });
      updateSuperCategory(superCategory);
    }
  }, [props?.superCategories]);

  return (
    <div style={{ background: 'white' }}>
      <div
        className="bgImage3"
        style={{
          backgroundImage: 'url(../../../../../img/liquor_banner.png)',
          marginTop: '4em',
          paddingLeft: '0',
          marginBottom: '0em',
          backgroundSize: 'cover',
          resize: 'both'
        }}
      >
        <div className="container">
          <div className="row">
            {/* <div
              className="col-lg-1 col-md-3 col-sm-4 col-5"
              style={{ textAlign: 'left', marginLeft: '2.5%', padding: '0px' }}
            ></div> */}
            <div className=" col-sm-auto col-7" style={{ textAlign: 'left' }}>
              <h1
                style={{ color: 'whitesmoke', fontWeight: 'bold' }}
                className="bgImage3Title"
              >
                {superCategory?.name}
              </h1>
              <h4 style={{ color: 'grey', fontSize: '1em' }}>
                {localStorage.getItem('city')}
              </h4>
              <h5 style={{ color: 'grey', fontSize: '0.9em' }}>
                {props?.vendorBySuperCategory?.length} Store
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <br />
        <div className={classes.superCategoryDetail}>
          <b
            className={classes.superCategoryImage}
            style={{ paddingLeft: '15px', fontWeight: 700 }}
          >
            {vendorBySuperCategory?.length} Outlets near you
            {/* {superCategory?.name} */}
            {/* <img className={classes.superCategoryImage} src={superCategory?.icon}/> */}
          </b>
        </div>
        <br />
        <div className={classes.root} style={{ background: 'white' }}>
          {/* <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            style={{
              width: '13.66%',
              marginLeft: '5px',
              textTransform: 'capitalize'
            }}
          ></Tabs> */}
          {!isLoading && (
            <TabPanel value={value} index={0} style={{ width: '100%' }}>
              <div className="container">
                <div className="container-fluid">
                  <div
                    style={{ textAlign: 'left' }}
                    className={classes.superCategoryImage}
                  >
                    {superCategory?.name}
                  </div>
                  <div className="row">
                    {vendorBySuperCategory?.length ? (
                      vendorBySuperCategory?.map((vendor) =>
                        !isRestaurant ? (
                          <GridItem xs={12} sm={12} md={4}>
                            <LiquorCard
                              icon={vendor?.logo}
                              name={vendor?.name}
                              street={vendor?.address?.street}
                              city={vendor?.address?.city}
                              days={vendor?.address?.days}
                              longitude1={vendor?.address?.longitude}
                              latitude1={vendor?.address?.latitude}
                              closetime={vendor?.timing?.sunday?.closeTime}
                              opentime={vendor?.timing?.sunday?.openTime}
                              id={vendor.id}
                              duration={vendor?.distanceAndDuration?.duration}
                              distance={vendor?.distance}
                            />
                          </GridItem>
                        ) : null
                      )
                    ) : (
                      <NoData />
                    )}
                  </div>
                </div>
              </div>
            </TabPanel>
          )}
          {/* {props.restaurantType
            ? restaurantType.map((item, index) => (
                <TabPanel
                  value={value}
                  index={index + 1}
                  style={{ width: '100%' }}
                >
                  <div className="container-fluid">
                    <div
                      style={{ textAlign: 'left' }}
                      className={classes.superCategoryImage}
                    >
                      {item.name}
                    </div>
                    <div className="row">
                      {props?.vendorBySuperCategory?.length ? (
                        props?.vendorBySuperCategory
                          ?.filter(
                            (categorieFilter) =>
                              categorieFilter.restaurantType === item.id
                          )
                          .map((vendor) =>
                            vendor.restaurantType.indexOf(item.name) >= 0 ? (
                              <GridItem xs={12} sm={12} md={4}>
                                <LiquorCard
                                  icon={vendor?.logo}
                                  name={vendor?.name}
                                  street={vendor?.address?.street}
                                  longitude1={vendor?.address?.longitude}
                                  latitude1={vendor?.address?.latitude}
                                  city={vendor?.address?.city}
                                  days={vendor?.address?.days}
                                  closetime={vendor?.address?.closetime}
                                  opentime={vendor?.address?.opentime}
                                  id={vendor.id}
                                  distance={vendor?.distance}
                                />
                              </GridItem>
                            ) : (
                              <GridItem xs={12} sm={12} md={4}>
                                <LiquorCard
                                  icon={vendor?.logo}
                                  name={vendor?.name}
                                  street={vendor?.address?.street}
                                  longitude1={vendor?.address?.longitude}
                                  latitude1={vendor?.address?.latitude}
                                  city={vendor?.address?.city}
                                  days={vendor?.address?.days}
                                  closetime={vendor?.address?.closetime}
                                  opentime={vendor?.address?.opentime}
                                  id={vendor.id}
                                  distance={vendor?.distance}
                                />
                              </GridItem>
                            )
                          )
                      ) : (
                        <NoData />
                      )}
                    </div>
                  </div>
                </TabPanel>
              ))
            : ""} */}
        </div>
      </div>
      <br />
      <br />
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  vendorBySuperCategory: state.user.vendorBySuperCategory,
  superCategories: state.user.superCategories,
  categories: state.user.categories,
  restaurantType: state.user.restaurantType
});

const mapDispatchToProps = (dispatch) => ({
  getAllSuperCategory: () => dispatch(getAllSuperCategory()),
  getVendorWithSuperCategory: (superCategory) =>
    dispatch(getVendorWithSuperCategory(superCategory)),
  getAllCategory: (superCategory) => dispatch(getAllCategory(superCategory)),
  getAllRestaurantType: (superCategory) =>
    dispatch(getAllRestaurantType(superCategory))
});

export default connect(mapStateToProps, mapDispatchToProps)(LiquorVendor);
